

import React from 'react';
import { connect } from 'react-redux';
import { Button, Input } from 'reactstrap';
// import ApuaWhiteTextLogo from '../../ImageAssets/ApuaWhiteTextLogo.png';
// import ApuaWhiteTextLogo from '../../ImageAssets/Apua_New_Logo.png';
import blueBanner from '../../ImageAssets/blueBanner.png';
import ApuaWhiteTextLogo from '../../ImageAssets/Apua_New_Logo_White.png';
import { setLoginPage, setUserRegisterDetails } from '../../General/Actions';
import Background from '../../ImageAssets/blueskyBackground.png';
import Network from '../../Utils/network.js';
import Swal from 'sweetalert2';
import { FaArrowLeft } from 'react-icons/fa';
import LoadingAnimation from '../../Utils/loadingAnimation.js';
import Constants from '../../Utils/constants.json';

class RegisterOtpComponent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: false,
            email: "",
            phoneNumber: "",
            registerOtp: "",
            time: {
                "h": 0,
                "m": 0,
                "s": 0
            },
            seconds: Constants.otpTimer,
            isOtpTimerEnds: false,
            resendOtpClicked: false,
            resendOtpCount: 0
        }
        this.timer = 0
    }

    componentDidMount() {
        this.updateWindowDimensions();
        window.addEventListener('resize', this.updateWindowDimensions);
        this.startTimer();
        // console.log("customer Id from redux =>> ",this.props.userRegisterDetails.customerId);
        // console.log("pin from redux =>> ",this.props.userRegisterDetails.pinNumber);
        // console.log("contactnumber from redux =>> ",this.props.userRegisterDetails.phoneNumber);
        // console.log("email from redux =>> ",this.props.userRegisterDetails.email);
        this.maskEmailAddress(this.props.userRegisterDetails.email);
        this.maskPhoneNumber(this.props.userRegisterDetails.profileContactNumber);
    }

    secondsToTime = (secs) => {
        let hours = Math.floor(secs / (60 * 60));

        let divisor_for_minutes = secs % (60 * 60);
        let minutes = Math.floor(divisor_for_minutes / 60);

        let divisor_for_seconds = divisor_for_minutes % 60;
        let seconds = Math.ceil(divisor_for_seconds);

        if (minutes < 10) {
            minutes = "0" + minutes;
        }
        if (seconds < 10) {
            seconds = "0" + seconds;
        }
        let obj = {
            "h": hours,
            "m": minutes,
            "s": seconds
        };
        return obj;
    }

    startTimer = () => {
        if (this.timer == 0 && this.state.seconds > 0) {
            this.timer = setInterval(this.countDown, 1000);
        }
    }

    countDown = () => {
        let seconds = this.state.seconds - 1;
        this.setState({ seconds: seconds });
        var element = document.getElementById("timer")
        if (typeof (element) != 'undefined' && element != null) {
            element.innerHTML = this.secondsToTime(seconds).m + ":" + this.secondsToTime(seconds).s + "s"
        }
        if (seconds == 0) {
            this.setState({ isOtpTimerEnds: true })
            clearInterval(this.timer);
        }
    }


    maskPhoneNumber(myNumber) {
        var maskedPhoneNumber = "";
        var cleaned = ('' + myNumber).replace(/\D/g, '');
        var match = cleaned.match(/^(\d{2})(\d{6})(\d{2})$/);
        if (match) {
            maskedPhoneNumber = [match[1], 'XXXXXX', match[3]].join('');
        }
        this.setState({
            phoneNumber: maskedPhoneNumber
        });
    }

    maskEmailAddress(myemailId) {
        var maskedEmail = "";
        var index = myemailId.lastIndexOf("@");
        var prefix = myemailId.substring(0, index);
        var postfix = myemailId.substring(index);

        var mask = prefix.split('').map(function (o, i) {
            if (i === 0 || i === (index - 1)) {
                return o;
            } else {
                return 'x';
            }
        }).join('');

        maskedEmail = mask + postfix;

        this.setState({
            email: maskedEmail
        });
    }

    updateWindowDimensions = () => {
        this.setState({ windowWidth: window.innerWidth, windowHeight: window.innerHeight });
    }

    inputValueChange(name, value) {
        this.setState({ [name]: value })
    }

    submitOtp() {
        if (this.props.userRegisterDetails.generatedOtp == this.state.registerOtp) {
            this.props.changeCurrentRegisterPartTo("registerCredentials");
        } else {
            Swal.fire(this.props.locales.RegisterOtpNtMatchingSwal, "", "");
        }
    }

    resendOtp() {
        var resendOtpCount = this.state.resendOtpCount + 1
        if (resendOtpCount <= 3) {
            this.timer = 0;
            this.setState({ resendOtpClicked: true })
            var generatedOtp = Math.floor(Math.random() * 90000) + 10000;
            this.props.setUserRegisterDetails("generatedOtp", generatedOtp);
            var dataToSendForOtp = {
                otp: generatedOtp,
                contactNum: this.props.userRegisterDetails.profileContactNumber
            }
            this.setState({ isLoading: true })
            Network.executeAxios("otpAuth", "POST", dataToSendForOtp, (responseForOtp) => {
                this.setState({ isLoading: false })
                if (responseForOtp.result_code && responseForOtp.result_code === "0") {
                    this.setState({ isOtpTimerEnds: false, seconds: Constants.otpTimer })
                    var otpTimer = Constants.otpTimer * 1000
                    setTimeout(() => {
                        this.setState({ resendOtpClicked: false });
                    }, otpTimer);
                    this.startTimer();
                    this.props.setUserRegisterDetails("generatedOtp", generatedOtp);
                } else {
                    Swal.fire(this.props.locales.internalErrorInForgetPwdPageSwal, "", "");
                }
            });
        }
        this.setState({ resendOtpCount: resendOtpCount })
    }

    render() {
        return (
            <div>
                <div id="toastPopup" className="animated slideInRight d-none"></div>
                {this.state.isLoading ? <LoadingAnimation isVisible={true} /> : null}
                {this.componentContent()}
            </div>
        );
    }

    componentContent() {
        const registerOtpOuterMainContainerStyle = { height: (this.state.windowHeight) + 'px', display: "flex", flexDirection: "column", justifyContent: "space-between" };
        return (
            <div style={registerOtpOuterMainContainerStyle}>
                <div className='p-5' style={{  backgroundImage: `url(${blueBanner})`,backgroundRepeat:"no-repeat",backgroundSize:"100% 100%",height: ((this.state.windowHeight)/100)*40 + 'px'}}>
                    <div className="col-md-6"><img alt="" src={ApuaWhiteTextLogo} /></div>
                </div>
                <div className="loginPageLeftPart col-md-3 row m-0 p-0 pt-5 mx-auto " style={{ height: 'inherit', alignItems: 'center', }}>
                <div className="col-md-12 text-center pb-2 pt-3" id="timer" style={{ fontWeight: 600, fontSize: 14 }}></div>
                    <div style={{flex:1}}>
                    <div className="form-group col-12 p-0">
                        <Input type="text" autoComplete="new-password" className="loginCredItem py-4"
                            placeholder={"Enter OTP"}
                            value={this.state.registerOtp}
                            style={{ color: '#404042', fontWeight: 500 }}
                            // onKeyUp={(event) => this.displayLabel(event, this.state.username, this.props.locales.loginPageEmailPlcText)}
                            onChange={(event) => this.inputValueChange("registerOtp", event.target.value)}
                        />
                         {this.state.isOtpTimerEnds && this.state.resendOtpClicked == false && this.state.resendOtpCount <= 3 ?
                            <div className="errorDesc pt-1 text-left">{this.props.locales.otpExpiredMsgInOtpTimer}</div>
                            : null}
                        {this.state.resendOtpClicked ?
                            <div className="errorDesc pt-1 text-left" style={{ color: '#36B07F' }}>{this.props.locales.newOtpSentMsgInOtpTimer}</div>
                            : null}
                        {this.state.resendOtpCount > 3 ?
                            <div className="errorDesc pt-1 text-left">{this.props.locales.maxOtpReqReachedMsgInOtpTimer}</div>
                            : null}
                            <div className="errorDesc" style={{ color: 'red', fontSize: 12, fontWeight: 400, position: 'absolute' }}></div>
                        </div>
                         <div className="col-md-12 d-flex align-items-center justify-content-center" style={{ marginTop: 40 }}>
                            <div className="col-md-8 loginPageLoginButton p-3" disabled={this.state.registerOtp === "" || this.state.isOtpTimerEnds ? true : false} onClick={() => { this.submitOtp() }}>
                             verify
                            </div>
                        </div>
                        <div className="d-flex pt-4 col-md-12 justify-content-center pb-3">
                            {this.state.isOtpTimerEnds ?
                                <div style={{ color: '#0285CA', fontSize: 16, fontWeight: 'bold', cursor: 'pointer' }} onClick={() => { this.resendOtp() }}>{this.props.locales.resendOtpInRegisterPart}</div>
                                :
                                <div style={{ fontWeight: 600, fontWeight: 'bold', color: '#0285CA', fontSize: 16, opacity: '0.5' }}>{this.props.locales.resendOtpInRegisterPart}</div>
                            }
                        </div>
                    </div>

                   
                </div>
                {/* <div className="row m-0" style={{ flex: 1 }}>
                    <div className="col-md-6 p-0 d-none d-sm-block" >
                        <div className="leftPartBackgroundImage" style={{ display: "flex", flexDirection: "column", height: "100%", flex: 1, alignItems: "center", justifyContent: "center", background: `url(${Background}) 20%`, backgroundSize: 'cover' }}>
                            {this.loginPartComponent()}
                        </div>
                    </div>
                    <div className="col-md-6 p-0" >
                        <div style={{ display: "flex", height: "100%", flex: 1, justifyContent: "center", backgroundColor: '#ffffff' }}>
                            {this.registerOtpComponent()}
                        </div>
                    </div>
                </div> */}
            </div>
        )
    }

    registerOtpComponent() {
        return (
            <div className="loginPageLeftPart col-md-12 row p-0 m-0">
                <div className="d-md-none col-md-12 p-0">
                    <div className="row col-md-12 m-auto py-2 px-2" style={{ backgroundColor: '#0285CA' }}>
                        <div className="col-md-12"><FaArrowLeft color="#fafafa" size="16" onClick={() => this.loginButtonClicked()} /> <img alt="" src={ApuaWhiteTextLogo} height="60" /></div>
                    </div>
                </div>
                <div className="col-md-12 row py-5 m-0 d-none d-sm-block">

                </div>

                <div className="col-md-12 row m-0">
                    <div className="col-md-1"></div>
                    <div className="col-md-10 pl-sm-5 pl-2 pt-0" id="registerOtpContainer">
                        <div className="col-md-12" style={{ fontSize: 18, color: '#404042' }}>{this.props.locales.registerCredentialAccountSignUpTxt}</div>
                        <div className="col-md-12" style={{ fontSize: 18, color: '#404042', fontWeight: 500 }}>{this.props.locales.registerOtpStepTxt}</div>
                        <div className="col-md-12" style={{ fontSize: 32, color: '#404042', fontWeight: 300 }}>{this.props.locales.registerOtpOTPTxt}</div>
                        <div className="col-md-12" style={{ fontSize: 16, color: '#404042', fontWeight: 300 }}>{this.props.locales.registerOtpVerificationCodeTxt}</div>
                        <div className="col-md-12" style={{ fontSize: 16, color: '#404042' }}><span style={{ fontWeight: 500 }}>{this.state.phoneNumber}</span></div>
                        <div className="col-md-12 text-center pb-2 pt-3" id="timer" style={{ fontWeight: 600, fontSize: 14 }}></div>
                        <div className="col-md-11 pb-3" >
                            <div className="col-12 row m-0 p-0">
                                <div className="form-group col-12 p-0">
                                    <label className="d-none animated slideInUp m-0" style={{ color: '#a3b4bc', fontSize: 12, position: 'absolute' }}>{this.props.locales.registerOtpEnterOtpTxt}</label>
                                    <Input type="text" name="registerOtp" autoComplete="new-password" style={{ color: '#404042' }}
                                        className="loginCredItem input_data_ pt-4 pb-3" placeholder={this.props.locales.registerOtpEnterOtpPlc}
                                        onChange={(event) => this.inputValueChange("registerOtp", event.target.value)}
                                        onKeyUp={(event) => this.displayLabel(event, this.state.registerOtp, this.props.locales.registerOtpEnterOtpPlc)} />
                                    {this.state.isOtpTimerEnds && this.state.resendOtpClicked == false && this.state.resendOtpCount <= 3 ?
                                        <div className="errorDesc pt-1 text-left">{this.props.locales.otpExpiredMsgInOtpTimer}</div>
                                        : null}
                                    {this.state.resendOtpClicked ?
                                        <div className="errorDesc pt-1 text-left" style={{ color: '#36B07F' }}>{this.props.locales.newOtpSentMsgInOtpTimer}</div>
                                        : null}
                                    {this.state.resendOtpCount > 3 ?
                                        <div className="errorDesc pt-1 text-left">{this.props.locales.maxOtpReqReachedMsgInOtpTimer}</div>
                                        : null}
                                    <div className="errorDesc" style={{ color: 'red', fontSize: 12, fontWeight: 400, position: 'absolute' }}></div>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-11">
                            <Button className="loginPageLoginButton" disabled={this.state.registerOtp === "" || this.state.isOtpTimerEnds ? true : false} onClick={() => { this.submitOtp() }}>
                                {this.props.locales.registerOtpVerifyBtn}
                            </Button>
                        </div>
                        <div className="d-flex pt-4 col-md-12 justify-content-center pb-3">
                            {this.state.isOtpTimerEnds ?
                                <div style={{ color: '#0285CA', fontSize: 16, fontWeight: 'bold', cursor: 'pointer' }} onClick={() => { this.resendOtp() }}>{this.props.locales.resendOtpInRegisterPart}</div>
                                :
                                <div style={{ fontWeight: 600, fontWeight: 'bold', color: '#0285CA', fontSize: 16, opacity: '0.5' }}>{this.props.locales.resendOtpInRegisterPart}</div>
                            }
                        </div>

                    </div>
                    <div className="col-md-1"></div>
                </div>
            </div>
        )
    }

    loginPartComponent() {
        return (
            <div className=" col-md-12 row m-0 d-flex flex-column" style={{ height: '100%' }}>
                <div className="col-md-12 row pt-5 m-0" style={{ flex: 1 }}>
                    <div className="col-md-1"></div>
                    <div className="col-md-6 pl-5 ml-3"><img alt="" src={ApuaWhiteTextLogo} /></div>
                    <div className="col-md-5"></div>
                </div>
                <div className="col-md-12 row p-0 m-0 " style={{ flex: 4, alignItems: 'center' }}>
                    <div className="col-md-1"></div>
                    <div className="loginPageLeftPart col-md-9" >
                        <div className="col-md-12  pl-5" style={{ marginTop: '-70px' }}>
                            <div className="mb-1 col-md-12" style={{ fontSize: 32, color: '#ffffff', fontWeight: 300 }}>{this.props.locales.registerFirstStepAlreadyHvAccountTxt}</div>
                            <div className="mb-5 pb-4 col-md-12" style={{ fontSize: 16, color: '#ffffff', fontWeight: 300 }}>{this.props.locales.registerFirstStepSignInHereTxt}</div>
                            <div className="col-md-12 " style={{ marginTop: 50 }}>
                                <Button className="loginPageRegisterButton" style={{ fontSize: 24, fontWeight: 500 }} onClick={() => { this.loginButtonClicked() }}>
                                    {this.props.locales.registerFirstStepSignInBtn}
                                </Button>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-2"></div>
                </div>
            </div>
        )
    }

    loginButtonClicked() {
        window.location.reload();
    }

    displayLabel(event, value, placeHolderText) {
        if (value != "") {
            event.target.previousSibling.classList.remove('d-none');
            event.target.placeholder = "";
        } else {
            event.target.previousSibling.classList.add('d-none');
            event.target.placeholder = placeHolderText;
        }
    }

}
const mapStateToProps = (state, ownProperties) => {
    return {
        locales: state.locales,
        userRegisterDetails: state.userRegisterDetails
    }
}
function mapDispatchToProps(dispatch) {
    return {
        setLoginPage: function (key, payload) {
            dispatch(setLoginPage(key, payload));
        },
        setUserRegisterDetails: function (key, payload) {
            dispatch(setUserRegisterDetails(key, payload))
        }
    }
}

const RegisterOtpComponentContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(RegisterOtpComponent)


export default RegisterOtpComponentContainer;
